var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#4B9BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8122 21.5443L31.4314 20.1636L22.4567 11.1888C22.3358 11.0679 22.1719 11 22.001 11C21.83 11 21.6661 11.0679 21.5452 11.1888L11.1898 21.5443C10.938 21.7959 10.938 22.2041 11.1898 22.4558C11.4415 22.7074 11.8495 22.7074 12.1013 22.4558L12.3817 22.1754V32.3555C12.3817 32.7114 12.6702 33 13.0262 33H19.2854V25.4518C19.2854 25.0958 19.5739 24.8072 19.9299 24.8072H24.0721C24.428 24.8072 24.7166 25.0958 24.7166 25.4518V33H30.9758C31.3317 33 31.6203 32.7114 31.6203 32.3555V22.1753L31.9007 22.4557C32.0266 22.5816 32.1915 22.6445 32.3564 22.6445C32.5213 22.6445 32.6863 22.5816 32.8121 22.4557C33.0639 22.2041 33.0639 21.7959 32.8122 21.5443Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.a9c66345d244a8a5fcca2af3569fe9f7.svg";
export { ForwardRef as ReactComponent };